import React from 'react'

const IconTelevente = (props) => {
  const {active} = props
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 48 48'>
        <g
          fill='none'
          stroke={`${active ? '#eeeeee' : '#5f00d5'}`}
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-width='3'
        >
          <path d='M24 45c14.5 0 20-3 20-14M6.803 35.783C5.119 35.362 4 33.825 4 32.09v-6.178c0-1.736 1.119-3.274 2.803-3.695c1.626-.407 3.762-.864 5.862-1.084c1.438-.151 2.704.692 2.943 2.117c.21 1.244.392 3.091.392 5.75c0 2.66-.183 4.507-.392 5.75c-.24 1.425-1.505 2.268-2.943 2.118c-2.1-.22-4.236-.678-5.862-1.085' />
          <path d='M41.197 35.783C42.881 35.362 44 33.825 44 32.09v-6.178c0-1.736-1.119-3.274-2.803-3.695c-1.626-.407-3.762-.864-5.862-1.084c-1.438-.151-2.704.692-2.943 2.117C32.182 24.494 32 26.341 32 29c0 2.66.183 4.507.392 5.75c.24 1.425 1.505 2.268 2.943 2.118c2.1-.22 4.236-.678 5.862-1.085' />
          <path d='M44 25.911V23c0-11.046-8.954-20-20-20S4 11.954 4 23v2.911m33.956-4.398C37.386 14.51 31.356 9 24 9s-13.386 5.51-13.956 12.513' />
        </g>
      </svg>
    )
  }

export default IconTelevente